dataLayerHandler = {
  events: () => {
    // Product card click
    if ($(".grid-item.grid-product").length > 0) {
      $("body").on(
        "click",
        ".grid-item__link, .grid-product__color-image",
        function (e) {
          e.preventDefault();

          const productCard = $(this).closest(".grid-product");

          let variant = $(productCard)
            .find(".variant-input.active")
            .data("value");
          let nicotine = "";
          if (variant && variant.includes("mg")) nicotine = variant;

          let index = 1;
          if ($(productCard).data("slick-index") >= 0)
            index = $(productCard).data("slick-index") + 1;
          else index = $(productCard).index() + 1;

          const productData = {
            title: $(productCard).data("product-title"),
            id: $(productCard).data("product-id"),
            price: $(productCard).find(".variant-input.active").data("price")
              ? $(productCard).find(".variant-input.active").data("price")
              : $.trim(
                  $(productCard).find(".price-one-time font font:first").text()
                ).replace("$", ""),
            brand:
              $(productCard).data("product-brand") || dataLayerDefaults.brand,
            variant: variant,
            nicotine: nicotine,
            category: $(productCard).data("category"),
            format: $(productCard).data("format"),
            flavour: $(productCard).data("flavour"),
            page_title: $(productCard).data("page_title"),
            page_slug: $(productCard).data("page_slug"),
            index: index,
            quantity: $(productCard).find(".qty").val(),
          };

          if ($("body.template-search").length > 0) {
            dataLayerHandler.callEvent("search_result_click", {
              index: index,
              id: $(productCard).data("product-id"),
            });
          }

          dataLayerHandler.callEvent(
            "select_item",
            productData,
            $(this).attr("href")
          );
        }
      );

      $("body").on(
        "change",
        ".grid-item.grid-product .sub-toggle input.sub-input",
        function () {
          if ($(this).is(":checked")) {
            const productCard = $(this).closest(".grid-item.grid-product");

            let index = 1;
            if ($(productCard).data("slick-index") >= 0)
              index = $(productCard).data("slick-index") + 1;
            else index = $(productCard).index() + 1;

            dataLayerHandler.callEvent("subscribe_toggle", {
              event: "Subscribe From",
              product: {
                title: productCard.data("product-title"),
                id: productCard.data("product-id").toString(),
                price: productCard.find(".variant-input.active").data("price"),
                index: index,
                variant: productCard
                  .find(".variant-input.active")
                  .data("value"),
                strength: productCard
                  .find(".variant-input.active")
                  .data("value"),
                format: productCard.data("format"),
                flavour: productCard.data("flavour"),
                systemType: productCard.data("systemType") ?? "Closed",
              },
            });
          }
        }
      );
    }

    if ($(".product-section").length > 0) {
      $("body").on(
        "change",
        ".product-section .subscriptions-payment-options .sub-toggle input.sub-input",
        function () {
          if ($(this).is(":checked")) {
            const productDetails = $(".product-section");

            dataLayerHandler.callEvent("subscribe_toggle", {
              event: "Subscribe Option Selected",
              product: {
                title: productDetails.data("product-title"),
                id: productDetails.data("product-id").toString(),
                price: productDetails
                  .find(".variant-input.active")
                  .data("price"),
                index: 1,
                variant: productDetails
                  .find(".variant-input.active")
                  .data("value"),
                strength: productDetails
                  .find(".variant-input.active")
                  .data("value"),
                format: productDetails.data("format"),
                flavour: productDetails.data("flavour"),
                systemType: productDetails.data("systemType") ?? "Closed",
              },
            });
          }
        }
      );
    }

    // Log out button clicked
    if ($(".sidebar_menu .sidebar_list").length > 0) {
      $("body").on(
        "click",
        ".sidebar_menu .sidebar_list:nth-child(3)",
        function () {
          dataLayerHandler.callEvent("logout");
        }
      );
    }

    // Login button clicked
    if ($(".login_customer").length > 0) {
      $("body").on("click", ".login_customer", function () {
        console.log("Logged in");
       // dataLayerHandler.callEvent("login");
      });
    }

// Add to Cart button clicked
    if ($(".add-to-cart-grid").length > 0) {
      $("body").on("click", ".add-to-cart-grid", function () {
           var productId = $(this)
    .closest(".data-product-id");
        
        var gaData = $(this).closest("[ga-item-data]");
        let item = {
          item_name: $(gaData).attr("data-title"), // Name or ID is required.
    item_id: $(gaData).attr("data-product-id"),
    item_brand: "Velo",
    item_category: $(gaData).attr("data-category"),
    //item_category_2: $(gaData).attr("data-category-2"),
    //item_category_3: $(gaData).attr("data-category-3"),
    //item_category_4: ($(gaData).attr("data-category-4")) ? $(gaData).attr("data-category-4") : "",
    item_variant: $(gaData).attr("data-variant"),
    item_list_name: $(gaData).attr("data-list-name"),
    item_list_id: $(gaData).attr("data-list-id"),
    index: $(gaData).attr("data-index"),
    quantity: "1",
     price: $(gaData).attr("data-price").replace(/,/g, '.'),
        }
        dataLayerHandler.callEvent("add_to_cart", item);
      });
    }

 // product detial page add to cart click
    if ($(".add-to-cart_custom").length > 0) {
      $("body").on("click", ".add-to-cart_custom", function () {
           var productId = document.querySelector('input[name=product-id]').value;
        console.log("product id",productId);
        var gaData = $(this).closest("[ga-item-data]");
        let item = {
          item_name: $(gaData).attr("data-title"), // Name or ID is required.
    item_id: productId,
    item_brand: "Velo",
    item_category: $(gaData).attr("data-category"),
    // item_category_2: $(gaData).attr("data-category-2"),
    // item_category_3: $(gaData).attr("data-category-3"),
    // item_category_4: ($(gaData).attr("data-category-4")) ? $(gaData).attr("data-category-4") : "",
    item_variant: $(gaData).attr("data-variant"),
    item_list_name:  $(gaData).attr("data-title"),
    item_list_id: $(gaData).attr("data-sku"),
    index: 1,
    quantity: "1",
    price: $(gaData).attr("data-price").replace(/,/g, '.'),
        }
        dataLayerHandler.callEvent("add_to_cart", item);
      });
    }


    
    // Remove from Cart button clicked
    if ($(".cart__remove").length > 0) {
      $("body").on("click", ".cart__remove", function () {
        let payload = {};
        for (let event of dataLayerEvents) {          
          if (event.key == "cart_view") payload = event.payload
        }
        dataLayerHandler.callEvent("remove_from_cart", payload);
      });
    }
  
  },

  checkParams: () => {
    const url = new URL(window.location.href);
    const search = url.search;

    if (search === "" || !search) return;

    const searchParts = search.replace("?", "").split("&");
    let newSearchParts = [];

    searchParts.map((part) => {
      const key = part.split("=")[0];
      const value = part.split("=")[1];

      if (!dataLayerHandler.trackableParams(key, value))
        newSearchParts.push(key + "=" + value);
    });

    let newSearch = "";
    if (newSearchParts.length > 0) newSearch = "?" + newSearchParts.join("&");

    const fixedUrl = url.origin + url.pathname + newSearch;
    if (fixedUrl != window.location.href)
      history.pushState(null, document.title, fixedUrl);
  },

  trackableParams: (key, value) => {
    if (key == "age-verified" && value == "true") {
      dataLayerHandler.callEvent("age_verified");
      return true;
    }

    return false;
  },

  checkMessages: () => {
    var msg = $(".errors").find("li").text();

    // Registration success - email verification visible
    var index = msg.indexOf(
      "please click the link included to verify your email address"
    );
    if (index !== -1) {
      $(".errors").addClass("email_successfull");
      dataLayerHandler.callEvent("registration");
    }
  },

  getCurrency: () => {
    return window.Shopify.currency.active || "EUR";
  },

  callEvent(event = "", payload = {}, location = null) {
    if (!payload || !event) return;

    if (dataLayerDefaults.mode.length) {
      dataLayerDefaults.mode.forEach((mode) => {
        if (providers[mode] && providers[mode][event]) {
          providers[mode][event](payload, location);
        } else {
          if (location) {
            setTimeout(() => {
              window.location = location;
            }, 1000);
          }
          if (dataLayerDefaults.debug)
            console.log(
              "DV dataLayer - No event found for " + event + " in " + mode
            );
        }
      });
    } else {
      if (dataLayerDefaults.debug)
        console.log("DV dataLayer - No modes enabled for dataLayer");
    }
  },

  pushEvent: (event, location = null) => {
    if (window.dataLayer || dataLayer) {
      dataLayer.push(event);

      if (dataLayerDefaults.debug)
        console.log("DV dataLayer - pushEvent", event);

      if (location) {
        if (dataLayerDefaults.debug) {
          console.log(event);
          if (window.confirm("DV dataLayer - Ready to move on?") == true)
            window.location = location;
        } else {
          setTimeout(() => {
            window.location = location;
          }, 1000);
        }
      }
    } else {
      if (location) window.location = location;
    }
  },
};

jQuery(() => {
  dataLayerHandler.events();
  dataLayerHandler.checkParams();
  if ($(".errors").length) dataLayerHandler.checkMessages();

  if (dataLayerDefaults.debug) console.log("DV dataLayer - Debug mode enabled");

  if (dataLayerEvents && dataLayerEvents.length > 0) {
    dataLayerEvents.map(({ key, payload, location }) => {
      dataLayerHandler.callEvent(key, payload ?? null, location ?? null);
    });
  }
});

const providers = {
  ga4: {
    view_item: (payload = {}) => {
      dataLayerHandler.pushEvent({
        event: "view_item",
        ecommerce: {
          items: [providers.ga4.transformItem(payload)],
        },
      });
    },

    select_item: (payload = {}, location = null) => {
      dataLayerHandler.pushEvent(
        {
          event: "select_item",
          ecommerce: {
            items: [providers.ga4.transformItem(payload)],
          },
        },
        location
      );
    },

    view_item_list: (payload = {}) => {
      var items = [];

      payload.products.map((product) =>
        items.push(providers.ga4.transformItem(product))
      );

      dataLayerHandler.pushEvent({
        event: "view_item_list",
        ecommerce: {
          items: items,
        },
      });
    },

    page_view: (payload = {}) => {
      let loggedInParams = {};

      if (payload.user) {
        // Logged in user params
         
        loggedInParams = {
          favouriteProduct: "",
          usualproduct: "",
          previousorders: payload.user.previousorders,
          previousorderedProducts: payload.user.previousorderedProducts,
          Subscription: "",
          subscribedProduct: "",
          subscribtionFrequency: "",
          subscribedItems: "",
          subscribedItemsPrice: "",
          emailsubscription: payload.user.emailsubscription,
          emailsubscriptionItem: payload.user.emailsubscriptionItem,
          ActivePaymentMethods: "",
          NumberOfActivePaymentMethods: "",
        };
      }

      payload && payload.page_type && payload.page_type == "index"
        ? (payload.page_type = "Homepage")
        : "";
      const event = {
        event: payload.user ? "all_pages_login" : "all_pages",
        UserID:
          payload.user && payload.user.customer_id
            ? JSON.stringify(payload.user.customer_id)
            : "",
        PageType: payload.page_type || "",
        SiteSection: payload.page_type || "",
         SystemType: (payload.page_type == 'Free trial' || payload.page_type == 'collection' || payload.page_type == 'product') ? 'Open system' : "",
        LoggedInStatus:
          payload.user && payload.user.customer_id ? "logged in" : "logged out",
        Country: window.Shopify.country,
        ServerSideTimestamp: JSON.stringify(new Date().getTime()),
        ...loggedInParams,
      };
      
      dataLayerHandler.pushEvent(event);
    },

    search: (payload = {}) => {
      dataLayerHandler.pushEvent({
        event: payload.results_count > 0 ? "search" : "unsuccesfulsearch",
        SearchTerm: payload.term || "",
        SearchResults: payload.results_count || 0,
        UserID: payload.customer_id || "",
        pageType: "searchResults",
      });
    },

    login: (payload = {}) => {
      let loggedInParams = {};
      if (payload.failed) {
        loggedInParams = {
          errorType: payload.failed.reason || "",
          errorFields: payload.failed.fields || "",
        };
      }

      dataLayerHandler.pushEvent({
        event: "account",
        eventAction: "login",
        eventLabel: payload.failed ? "fail" : "success",
        ...loggedInParams,
      });
    },

    logout: () => {
      dataLayerHandler.pushEvent({
        event: "account",
        eventAction: "logout",
        eventLabel: "success",
      });
    },
  
    registration: (payload = {}) => {
      let registrationParams = {};

      if (payload.failed) {
        registrationParams = {
          errorType: payload.failed.reason || "",
          errorFields: payload.failed.fields || "",
        };
      }

      dataLayerHandler.pushEvent({
        event: "registration",
        eventAction: "registration " + payload.failed ? "Failure" : "Success",
        eventLabel: payload.failed ? "fail" : "success",
        ...registrationParams,
      });
    },

    add_to_cart: (item = {}, location = null) => {
     
      let items = [];
      items.push(item);
        dataLayerHandler.pushEvent(
          {
            event: "add_to_cart",
            ecommerce: {
              items: items,
            },
          },
          location
        );
      
    },

    remove_from_cart: (payload = {}, location = null) => {
      let items = [];
      if (payload.products)
        payload.products.map((product) =>
          items.push(providers.ga4.transformItem(product))
        );
      if (items.length > 0) {
        dataLayerHandler.pushEvent(
          {
            event: payload.event ?? "remove_from_cart",
            ecommerce: {
              items: items,
            },
          },
          location
        );
      }
    },

     login: (payload = {}) => {
            let loggedInParams = {};

            if (payload.failed) {
                return
            }

            // dataLayerHandler.pushEvent({
            //     event: "login_success",
            //     form: "lLogingin",
            //     formType: "Login",
            //     eventTrigger: "Header"
            // });
        },

    begin_checkout: (payload = {}) => {
      var items = [];

      payload.products.map((product) =>
        items.push(providers.ga4.transformItem(product))
      );

      dataLayerHandler.pushEvent({
        event: "begin_checkout",
        ecommerce: {
          items: items,
        },
      });
    },

    purchase: (payload = {}) => {
      var items = [];

      payload.products.map((product) =>
        items.push(providers.ga4.transformItem(product))
      );

      dataLayerHandler.pushEvent({
        event: "purchase",
        ecommerce: {
          transaction_id: payload.transaction_id || "",
          value: payload.value || 0,
          tax: payload.tax || 0,
          shipping: payload.shipping || 0,
          currency: payload.currency || dataLayerHandler.getCurrency(),
          coupon: payload.coupon || "",
          purchase_type: payload.purchase_type || "",
          items: items,
        },
      });
    },

    transformItem: (product = {}) => {
      let affiliation = "";
      if (window.store_affiliation) affiliation = window.store_affiliation;
      if (product.affiliation) affiliation = product.affiliation;

      let item = {
        item_name: product.title,
        item_id: product?.id?.toString(),
        price: product.price.replace(/,/g, '.'),
        item_brand: product.brand || dataLayerDefaults.brand,
        item_category: product.type || "",
        //item_category_2: product.format || "",
        //item_category_3: product.flavour || "",
        //item_category_4: product.nicotine || "",
        item_variant: product.variant || product.title,
        item_list_name: product.page_title || dataLayerDefaults.page_title,
        item_list_id: product.page_slug || dataLayerDefaults.page_slug,
        index: product.index || 1,
        quantity: JSON.stringify(product.qty) || "1",
        //affiliation: affiliation,
      };

      if (product.voucher_code) item.item_coupon = product.voucher_code;
      if (product.discount && product.discount > 0)
        item.discount = product.discount;

      return item;
    },
  },
};


